import { configure } from '@testing-library/react';

configure({ testIdAttribute: 'data-hook' });

beforeAll(() => {
  window.ResizeObserver = jest.fn().mockImplementation(() => ({
    observe: jest.fn(),
    unobserve: jest.fn(),
    disconnect: jest.fn(),
  }));
});
